import classNames from 'clsx';
import { QRCodeCanvas } from 'qrcode.react';
import React, { memo } from 'react';
import { multiSessionRestrictionConfig } from 'reactApp/appHelpers/featuresHelpers/features/multiSessionRestriction';
import { cdnPackagesUrl } from 'reactApp/appHelpers/themeToolHelpers/default-values';

import styles from './MultiCookieQr.css';

const { qr: qrConfig } = multiSessionRestrictionConfig;

const trkWrapper = (url: string) => {
    if (!qrConfig.trk_enabled) {
        return url;
    }
    const params = new URLSearchParams({ mt_deeplink: url, mt_sub1: url });

    return `${qrConfig.trk_url}?${params.toString()}`;
};

interface Props {
    url: string;
    isLoading?: boolean;
    size?: number;
}

const imageSettings = {
    src: `${cdnPackagesUrl}/static/octavius/multi-session-restriction-modal/b2b/max_logo.svg`,
    height: 28,
    width: 28,
    excavate: true,
};

const tooltipUrl = `${cdnPackagesUrl}/static/cloud/multi-session/qr-tooltip-dark-v2.png`;

export const B2bBotQr = memo(({ url, isLoading, size = 164 }: Props) => {
    return (
        <div className={styles.qrWrapper}>
            <img src={tooltipUrl} alt="" className={styles.tooltip} />
            <div
                className={classNames(styles.qrCode, {
                    [styles.loading]: isLoading,
                    [styles.fadeIn]: !isLoading,
                })}
            >
                {!isLoading && (
                    <QRCodeCanvas
                        value={trkWrapper(url)}
                        size={size}
                        imageSettings={qrConfig.max_logo_enabled ? imageSettings : undefined}
                        bgColor={'#ffffff'}
                        fgColor={'#000000'}
                    />
                )}
            </div>
        </div>
    );
});

B2bBotQr.displayName = 'B2bBotQr';
